import FetchUserOrders from '@/services/orders/FetchUserOrders';

export default class OrderService {
    /**
     * Get all the user's orders.
     *
     * @param {number} userId
     * @param {number} page
     *
     * @returns {Promise}
     */
    fetchUserOrders(userId, page) {
        return (new FetchUserOrders()).handle(userId, page);
    }
}
